<template>
  <div class="product-card">
    <router-link :to="`/product/${product.slug}`" class="product-image">
      <img 
        v-if="product.images && product.images[0]" 
        :src="getImageUrl(product.images[0].image_path)" 
        :alt="product.name"
      >
      <div v-else class="product-image-placeholder">
        <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        </svg>
      </div>
      
      <!-- Stock Badge -->
      <div v-if="product.stock_quantity <= 0" class="stock-badge out-of-stock">
        สินค้าหมด
      </div>
      <div v-else-if="product.stock_quantity <= 5" class="stock-badge low-stock">
        เหลือ {{ product.stock_quantity }} ชิ้น
      </div>
    </router-link>
    
    <div class="product-info">
      <p v-if="product.category" class="product-category">{{ product.category.name }}</p>
      <h3 class="product-name">
        <router-link :to="`/product/${product.slug}`">{{ product.name }}</router-link>
      </h3>
      <p v-if="product.description" class="product-desc">{{ product.description }}</p>
      <div class="product-price">฿{{ Number(product.price).toLocaleString() }}</div>
      <div class="product-actions">
        <router-link :to="`/product/${product.slug}`" class="btn btn-outline btn-sm" style="flex: 1;">
          ดูรายละเอียด
        </router-link>
        <button 
          @click="addToCart" 
          :disabled="product.stock_quantity <= 0"
          class="btn btn-primary btn-sm"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCartStore } from '../stores/cart';
import { useNotification } from '../composables/useNotification';
import { getImageUrl } from '../utils/imageUrl';

const props = defineProps({
  product: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['add-to-cart']);
const cartStore = useCartStore();
const { showSuccess, showError } = useNotification();

const addToCart = async () => {
  if (props.product.stock_quantity <= 0) return;
  
  try {
    await cartStore.addToCart(props.product.id, null, 1);
    emit('add-to-cart', props.product);
    showSuccess(`เพิ่ม "${props.product.name}" ลงตะกร้าแล้ว`);
  } catch (error) {
    console.error('Add to cart error:', error);
    showError('ไม่สามารถเพิ่มสินค้าได้');
  }
};
</script>

<style scoped>
.product-category {
  font-size: 0.75rem;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.25rem;
}

.product-image {
  position: relative;
  display: block;
}

.product-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  background: #f9fafb;
  color: #d1d5db;
}

.stock-badge {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 0.25rem;
}

.stock-badge.out-of-stock {
  background: #fee2e2;
  color: #991b1b;
}

.stock-badge.low-stock {
  background: #fef3c7;
  color: #92400e;
}

.product-name a {
  color: inherit;
  text-decoration: none;
}

.product-name a:hover {
  color: var(--color-primary);
}
</style>
